// <label data-form-select>
//     <span data-form-select-label>AKTIVT VAL TEXT</span>
//     <select data-form-select-select name=" ... ">
//         <option value=" .. " selected="selected">VAL 1</option>
//         <option value=" .. ">VAL 2</option>
//     </select>
// </label>
import { component } from 'flightjs';

function FormSelectUI() {
    this.defaultAttrs({
        selectMethod: 'data-form-select-method',
        dropdownSelector: '[data-form-select-select]',
        dropdownLabel: '[data-form-select-label]',
        navigateEvent: 'ui:navigate'
    });

    this._selectChange = function() {
        this._updateLabel();
        let selectMethod = this.$node.attr(this.attr.selectMethod);

        if (selectMethod === 'gotovalue') {
            let optionValue = this.select('dropdownSelector').val();
            this._handleUrl(optionValue);
        }
    };

    this._handleUrl = function(url) {
        let selected = this.select('dropdownSelector').find(':selected');

        if (
            this.$node.is('[data-form-select-ga-category]') &&
            this.$node.is('[data-form-select-ga-action]') &&
            selected.is('[data-form-select-ga-label]')
        ) {
            this._addGaAndGotoUrl(selected, url);
        } else {
            this._gotoUrl(url);
        }
    };

    this._addGaAndGotoUrl = function(selected, url) {
        let callbackDone = false;

        let hitCallback = function() {
            if (callbackDone === false) {
                // callback should never be ran twice (ipad issue when using hitCallback + setTimeout)
                this._gotoUrl(url);
            }
            callbackDone = true;
        }.bind(this);

        this.trigger(document, 'analytics:track-event', {
            category: this.$node.attr('data-form-select-ga-category') || '',
            action: this.$node.attr('data-form-select-ga-action') || '',
            label: selected.attr('data-form-select-ga-label') || '',
            hitCallback: hitCallback
        });

        setTimeout(function() {
            hitCallback();
        }, 1000);
    };

    this._gotoUrl = function(url) {
        this.trigger(document, this.attr.navigateEvent, { href: url });
    };

    this._updateLabel = function() {
        // Value: optionValue = this.select('dropdownSelector').val()
        let optionLabel = this.select('dropdownSelector')
            .find(':selected')
            .text();
        this.select('dropdownLabel').text(optionLabel);
    };

    this.after('initialize', function() {
        this.on('change', {
            dropdownSelector: this._selectChange
        });

        this.on('ui:select-or-input-text:on-select-change', this._selectChange);
        this.on('ui:navigation:after-page-change', this._updateLabel);
        this._updateLabel();
    });
}

export default component(FormSelectUI);
